import type { AuthUser } from '@gb-ticket/shared-types';

import { platformAdminLinks } from '@/platform/lib/admin';
import {
  PROFILE_ACCOUNT_PATH,
  PROFILE_APPEARANCE_PATH,
  PROFILE_DEVICES_PATH,
  PROFILE_NOTIFICATIONS_SETTINGS_PATH,
  PROFILE_OVERVIEW_PATH,
  PROFILE_SECURITY_PATH,
  PROFILE_ADMIN_LINKS_PATH,
  type ProfileNavLink,
} from '@/platform/lib/profile-paths';
import { profileSectionNavEntriesFor } from '@/platform/lib/profile-sections';

/** Sidebar entries for `/profil/*` in display order. */
export function profileNavLinks(user: AuthUser | null | undefined): ProfileNavLink[] {
  if (!user) {
    return [];
  }

  const links: ProfileNavLink[] = [
    { id: 'overview', label: 'Übersicht', to: PROFILE_OVERVIEW_PATH, end: true },
    { id: 'account', label: 'Kontodaten', to: PROFILE_ACCOUNT_PATH },
    { id: 'appearance', label: 'Darstellung', to: PROFILE_APPEARANCE_PATH },
    { id: 'security', label: 'Sicherheit', to: PROFILE_SECURITY_PATH },
    { id: 'notifications', label: 'Mitteilungen', to: PROFILE_NOTIFICATIONS_SETTINGS_PATH },
    { id: 'devices', label: 'Geräte', to: PROFILE_DEVICES_PATH },
  ];

  for (const entry of profileSectionNavEntriesFor(user)) {
    links.push({
      id: `module-${entry.path}`,
      label: entry.navLabel,
      to: `${PROFILE_OVERVIEW_PATH}/${entry.path}`,
    });
  }

  if (platformAdminLinks(user).length > 0) {
    links.push({ id: 'admin', label: 'Verwaltung', to: PROFILE_ADMIN_LINKS_PATH });
  }

  return links;
}

export function activeProfileNavLink(
  links: readonly ProfileNavLink[],
  pathname: string,
): ProfileNavLink | undefined {
  const ordered = [...links].sort((a, b) => b.to.length - a.to.length);
  return ordered.find((link) =>
    link.end ? pathname === link.to : pathname === link.to || pathname.startsWith(`${link.to}/`),
  );
}

export function isProfileModulePathAllowed(
  user: AuthUser | null | undefined,
  segment: string | undefined,
): boolean {
  if (!user || !segment) {
    return false;
  }
  return profileSectionNavEntriesFor(user).some((entry) => entry.path === segment);
}
